import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 45px;
  background-color: #206da7;
  position: relative;
  align-items: center;

  .menu-left {
    display: flex;
    flex-direction: row;
    color: ${({ theme }) => theme.palette.common.white};
    gap: 1.8rem;
    list-style: none;
  }

  .menu-right {
    display: flex;
    flex-direction: row;
    color: ${({ theme }) => theme.palette.common.white};
    gap: 1.8rem;
    list-style: none;
  }

  .login {
    border-left: 1px solid ${({ theme }) => theme.palette.common.white};
    display: flex;
    margin-left: 10px;
    padding-left: 20px;
    padding-right: 10px;
    max-width: 16rem;
    justify-content: start;
    align-items: center;
    gap: 5px;
    height: 30px;
    cursor: pointer;

    p {
      color: ${({ theme }) => theme.palette.common.white};
      margin: 0;
      /* padding-left: 12px; */
    }

    button.btn-logout {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: start;
      gap: 20px;
      :hover {
        filter: brightness(0.8);
      }
    }

    svg {
      color: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

export const Section = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  img {
    width: 90px;
  }
`;

export const Typography = styled(Box)`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: #616161;
  margin: 5px 0px 5px 15px;
`;

export const CompanyName = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #fafafa;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: start;
`;

export const TextMenu = styled(Typography)`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 23px;
  text-align: center;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #4c4c4c;
`;

export const SectionHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border-style: 'hidden';
  }
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #000000;
  margin: 0;
`;

export const Card = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 25px;
  gap: 3px;
  width: 100%;
  border-top: 1px solid #d9d9d9;
  :hover {
    background-color: #fbfbfb;
  }
`;

export const Date = styled(Typography)`
  margin: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
`;

export const TitleCard = styled(Typography)`
  margin: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Description = styled(Typography)`
  margin: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
`;

export const Warning = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 25px;
  gap: 3px;
  width: 100%;
  height: 127px;
  border-top: 1px solid #d9d9d9;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #323232;
`;
